"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyQuery = stringifyQuery;
exports.parseQuery = parseQuery;
const qs_1 = require("qs");
function stringifyQuery(query) {
    return (0, qs_1.stringify)(query, { arrayFormat: 'repeat', skipNulls: true });
}
function parseQuery(queryString = '') {
    const query = (0, qs_1.parse)(queryString.replace('?', ''));
    return query;
}
//# sourceMappingURL=query.js.map